import React from 'react';
import { Plus } from 'lucide-react';
import AdsButton from './AdsButton';

/**
 * Canonical list-page primary add action — matches Dépenses « Ajouter » pill.
 * Place in DashboardFamilyHeader actions (manager) or PageHeader / toolbar (worker).
 */
const ListPageAddButton = ({ children, className = '', ...props }) => (
  <AdsButton
    variant="primary"
    className={`ads-list-add-btn${className ? ` ${className}` : ''}`}
    {...props}
  >
    <Plus size={15} strokeWidth={2} aria-hidden />
    {children}
  </AdsButton>
);

export default ListPageAddButton;
